import React, { useState } from 'react';
import './Gallery.css';

// Importing all images
import Gallery_image_1 from '../Gallery/ImageGallery/IMG_6970.JPG';
import Gallery_image_2 from '../Gallery/ImageGallery/IMG_6971.JPG';
import Gallery_image_3 from '../Gallery/ImageGallery/IMG_3207.JPG';
import Gallery_image_4 from '../Gallery/ImageGallery/IMG_6974.JPG';
import Gallery_image_5 from '../Gallery/ImageGallery/IMG_6976.JPG';
import Gallery_image_6 from '../Gallery/ImageGallery/IMG_6978.JPG';
import Gallery_image_7 from '../Gallery/ImageGallery/IMG_6979.JPG';
import Gallery_image_8 from '../Gallery/IMG_3005.JPG';
import Gallery_image_9 from '../Gallery/ImageGallery/IMG_1365 (FILEminimizer).JPG';
import Gallery_image_10 from '../Gallery/ImageGallery/IMG_1610 (FILEminimizer).JPG';
import Gallery_image_11 from '../Gallery/ImageGallery/IMG_6982.JPG';
import Gallery_image_12 from '../Gallery/ImageGallery/DSC_0114.JPG';
import Gallery_image_13 from '../Gallery/ImageGallery/IMG_6969.JPG';
import Gallery_image_14 from '../Gallery/ImageGallery/IMG_1646 (FILEminimizer).JPG';
import Gallery_image_15 from '../Gallery/ImageGallery/IMG_1621 (FILEminimizer).JPG';
import Gallery_image_16 from '../Gallery/ImageGallery/IMG_7290.JPG';
import Gallery_image_17 from '../Gallery/ImageGallery/IMG_7293.JPG';
import Gallery_image_18 from '../Gallery/ImageGallery/IMG_7289.JPG';
import Gallery_image_19 from '../Gallery/ImageGallery/IMG_7291.JPG';
import Gallery_image_20 from '../Gallery/ImageGallery/IMG_7292.JPG';
import Gallery_image_21 from '../Gallery/ImageGallery/IMG_7306.JPG';
import Gallery_image_22 from '../Gallery/ImageGallery/IMG_7304.JPG';
import Gallery_image_23 from '../Gallery/ImageGallery/WhatsApp Image 2025-02-21 at 09.43.47.jpeg';

const Gallery = () => {
  const images = [
    Gallery_image_1, Gallery_image_2, Gallery_image_3, Gallery_image_4, Gallery_image_5,
    Gallery_image_6, Gallery_image_7, Gallery_image_8, Gallery_image_9, Gallery_image_10,
    Gallery_image_11, Gallery_image_12, Gallery_image_13, Gallery_image_14 , Gallery_image_15,Gallery_image_16,
    Gallery_image_17,Gallery_image_18,Gallery_image_19,Gallery_image_20,Gallery_image_21,Gallery_image_22,Gallery_image_23 
  ];

  const [zoomedImage, setZoomedImage] = useState(null);

  const handleZoom = (image) => {
    if (zoomedImage === image) {
      setZoomedImage(null); 
    } else {
      setZoomedImage(image); 
    }
  };

  const handleBack = () => {
    setZoomedImage(null); // Close the zoomed image
  };

  return (
    <div className="gallery-main-container">
      <div className={`images-gallery ${zoomedImage ? 'zoomed-gallery' : ''}`}>
        {images.map((image, index) => (
          <div className="image-gallery1" key={index}>
            <img 
              src={image} 
              className={`Gallery_image_1 ${zoomedImage === image ? 'zoomed' : ''}`} 
              alt={`gallery-img-${index}`} 
              onClick={() => handleZoom(image)} 
              style={{ height: '250px', width: '300px' }}
            />
          </div>
        ))}
      </div>

      {zoomedImage && (
        <div className="zoomed-image-container">
          <img
            src={zoomedImage}
            alt="Zoomed Full View"
            className="zoomed-image"
            style={{ height: '500px', width: '650px' }}
          />
          <button className="back-button" onClick={handleBack}>
            Back to Gallery
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
